export const formatName = (fullName: string) => {
  const name = fullName.split(' ');
  return `${name[0]}`;
};
